// @flow

import Game from '@/lib/game';

export default class {
  static isSatisfied(game: Game): boolean {
    const { creAdultTreesCount } = game.stats;
    return creAdultTreesCount >= 9 && game.virtualTime.season === 'autumn';
  }

  static makeAchievement() {
    return {
      uid: 'cre_forest',
      title: '食欲の秋',
      body: '栗の木がたくさん！ 栗ごはんが食が進みます。',
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/achievement_conditions/cre_forest.js